module.exports = __webpack_public_path__ + "img/3_autumn.b0feb17c.png";